// Keep the default aligned with akas-be/config/app.php, independent of the device timezone.
export const APPLICATION_TIME_ZONE = process.env.REACT_APP_TIMEZONE || "Asia/Jakarta";

export const applicationToday = (now = new Date(), timeZone = APPLICATION_TIME_ZONE) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone, year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(now);
  const values = Object.fromEntries(parts.map(({ type, value }) => [type, value]));
  return `${values.year}-${values.month}-${values.day}`;
};

export const todayAnalysisRange = (now = new Date()) => {
  const today = applicationToday(now);
  return { startDate: today, endDate: today };
};
